// Texty přihlášení/registrace/obnovy hesla (authPage.js). Čísla trust karty
// (skóre, počet zákazníků, hodnocení) NEJSOU tady — jdou z `reviewSummary()`
// (reviews.js), tady zůstávají jen slova kolem čísel.
import { NBSP } from '../../modules/money.js';

export default {
  head: {
    login: { title: 'Vítejte zpět', sub: 'Přihlaste se ke svému účtu Jipos' },
    register: { title: 'Založit účet', sub: 'Registrace zabere necelou minutu' },
  },
  tabs: {
    login: 'Přihlášení',
    register: 'Registrace',
  },
  switchText: {
    login: { text: 'Nemáte účet?', link: 'Zaregistrujte se' },
    register: { text: 'Už máte účet?', link: 'Přihlaste se' },
  },
  labelEmail: 'E-mail',
  labelPassword: 'Heslo',
  labelForgot: 'Zapomenuté heslo?',
  labelBack: 'Zpět na přihlášení',
  typeDesc: {
    retail: 'Běžný nákup pro sebe',
    wholesale: 'Firma s IČ, vlastní ceník',
  },
  b2bNote: 'Velkoobchodní ceník schvalujeme ručně. Po registraci se vám ozveme do jednoho pracovního dne.',
  panel: {
    eyebrow: 'Účet Jipos',
    title: 'Nakupujte rychleji a mějte vše pod kontrolou',
  },
  benefits: [
    { icon: 'package', title: 'Přehled objednávek', text: 'Historie nákupů a stav zásilek na jednom místě' },
    { icon: 'bolt', title: 'Rychlejší nákup', text: 'Uložené doručovací a fakturační údaje' },
    { icon: 'heart', title: 'Oblíbené produkty', text: 'Uložte si nářadí, ke kterému se chcete vrátit' },
    { icon: 'percent', title: 'Věrnostní slevy', text: 'Exkluzivní akce a slevy jen pro přihlášené' },
    { icon: 'store', title: 'B2B ceny', text: 'Firmy s IČO získají velkoobchodní ceník až −20' + NBSP + '%' },
  ],
  trust: {
    before: 'Přes ',
    between: ' a ',
    after: ' ověřených hodnocení. Nakupujte bezpečně.',
  },
};
